import React from 'react';

const HostingInfo = () => {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Hosting Information</h2>
      <ul className="space-y-2 text-gray-600">
        <li><strong>Host:</strong> OVH SAS</li>
        <li><strong>Address:</strong> 2 rue Kellermann, 59100 Roubaix, France</li>
        <li><strong>Phone:</strong> +33 8 99 70 17 61</li>
        <li><strong>Website:</strong> <a href="https://www.ovh.com" className="text-blue-600 hover:underline">www.ovh.com</a></li>
      </ul>
    </section>
  );
};

export default HostingInfo;